<div class="call-container">
    <div class="header-div">
        <h3>
            <i class="fa fa-phone" aria-hidden="true"></i> 
            Call us</h3>
    </div>
    <div class="body-content">
        <div class="row">
            <div class="col px-md-2 px-2">
                <div class="headder-courses g1 middle">
                    <h2 [matTooltip]="'+91 8130900243'"
                    matTooltipPosition="below" (click)="addCallClickData('CAT Exam')">
                        <a href="tel:+91 8130900243">
                            <i class="fa fa-phone" aria-hidden="true"></i> 
                            CAT Exam</a></h2>
                </div>
            </div>

            <div class="col px-md-2 px-2">
                <div class="headder-courses g2 middle">
                    <h2 [matTooltip]="'+91 8130900243'" (click)="addCallClickData('MBA Exam')"
                    matTooltipPosition="below"><a href="tel:+91 8130900243">
                      <span>Other</span>
                      <i class="fa fa-phone" aria-hidden="true"></i> MBA Exam</a></h2>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col px-md-2 px-2">
                <div class="headder-courses g3 middle">
                    <h2 [matTooltip]="'+91 8130900243'" (click)="addCallClickData('GMAT Exam')"
                    matTooltipPosition="below"><a href="tel:+91 8130900243">
                        <i class="fa fa-phone" aria-hidden="true"></i> GMAT EXAM <span>& STUDY ABROAD</span></a></h2>
                </div>
            </div>

            <div class="col px-md-2 px-2">
                <div class="headder-courses g4 middle" >
                    <h2 [matTooltip]="'+91 8130900243'" (click)="addCallClickData('CUET Exam')"
                    matTooltipPosition="below"><a href="tel:+91 8130900243">
                        <i class="fa fa-phone" aria-hidden="true"></i> CUET EXAM <span>IPMAT | CLAT</span></a></h2>

                </div>
            </div>
           
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="headder-courses g5 middle" style="   background: #e53145 !important; height: 52px;">
                    <h2 [matTooltip]="'+91 8130900243'" (click)="addCallClickData('CSAT Course')"
                    matTooltipPosition="below"><a href="tel:+91 8130900243">
                        <i class="fa fa-phone" aria-hidden="true"></i>IIT-JEE Exam</a></h2>
                </div>
            </div>
            <div class="col-md-12">
                <div class="headder-courses g5 middle">
                    <h2 [matTooltip]="'Message Now'" (click)="addCallClickData('Message us on Whatsapp')"
                    matTooltipPosition="below"><a href="https://wa.me/918130900243">
                        <i class="fa fa-phone" aria-hidden="true"></i> Message us on Whatsapp</a></h2>
                </div>
            </div>
            <div class="col-md-12">
                <div class="headder-courses g1 middle">
                    <h2 [matTooltip]="'+91 95158 43236'" (click)="addCallClickData('For business enquiries')"
                    matTooltipPosition="below"><a href="tel:+91 95158 43236">
                        <i class="fa fa-phone" aria-hidden="true"></i> For business enquiries
                    </a></h2>
                </div>
            </div>
            <div class="col-md-12 mt-4">
                <h6>Mail us at: info@iquanta.in</h6>
            </div>
        </div>

    </div>
</div>